export function jwtTokenGetter() {
  return localStorage.getItem('token');
}
